var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 42.6667,
    transform: "translate(0 0.108154)",
    fill: "#F5CD22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5415C17.5 14.2102 17.7686 13.9415 18.1 13.9415H31.9C32.2314 13.9415 32.5 14.2102 32.5 14.5415V16.6749C32.5 17.0062 32.2314 17.2749 31.9 17.2749H18.1C17.7686 17.2749 17.5 17.0062 17.5 16.6749V14.5415ZM18.3333 18.7082C18.3333 18.3768 18.602 18.1082 18.9333 18.1082H31.0667C31.398 18.1082 31.6667 18.3768 31.6667 18.7082V28.3415C31.6667 28.6729 31.398 28.9415 31.0667 28.9415H18.9333C18.602 28.9415 18.3333 28.6729 18.3333 28.3415V18.7082ZM22.9167 20.6082C22.8062 20.6082 22.7002 20.6521 22.622 20.7302C22.5439 20.8084 22.5 20.9144 22.5 21.0249V22.2749H27.5V21.0249C27.5 20.9144 27.4561 20.8084 27.378 20.7302C27.2998 20.6521 27.1938 20.6082 27.0833 20.6082H22.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminArchive);
export default __webpack_public_path__ + "static/media/adminArchive.2e784f94250e205f29e8596e8e602c45.svg";
export { ForwardRef as ReactComponent };